export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Онц', 'Гайхалтай', 'Сайн байна!']
export const GAME_COPIED_MESSAGE = 'Тоглолт "clipboard" хуулагдлаа'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Үсгийн тоо хангалтгүй байна'
export const WORD_NOT_FOUND_MESSAGE = 'Үг олдсонгүй'
export const HARD_MODE_ALERT_MESSAGE =
  '"Хэцүү Горим"-г зөвхөн тоглоом идэвхжүүлэх боломжтой'
export const CORRECT_WORD_MESSAGE = (solution: string) => `Зөв үг ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `${position} байрлалд ${guess} ашиглах ёстой`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Үсэг "${letter}" агуулагдсан байх ёстой`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = 'Статистикууд'
export const GUESS_DISTRIBUTION_TEXT = 'Оролдлогын хуваарьлалт'
export const NEW_WORD_TEXT = 'Дараагийн шинэ үг хүртэл'
export const SHARE_TEXT = 'Хуваацлах'
export const TOTAL_TRIES_TEXT = 'Нийт оролдлого'
export const SUCCESS_RATE_TEXT = 'Амжилтын түвшин'
export const CURRENT_STREAK_TEXT = 'Одоогийн streak'
export const BEST_STREAK_TEXT = 'Хамгийн сайн streak'
